import * as React from 'react';
import { CptClientDataGrid } from '../components/CptClientDataGrid';
import { KeldomAlertDialog } from '../components/KeldomAlertDialog';

export function EditClientOnFacture({
  factureId,
  currentCustomerId,
}: {
  factureId?: number;
  currentCustomerId?: number;
}) {
  const [selectedClient, setSelectedClient] = React.useState<number | null>(
    null,
  );

  const handleChangeCodeClient = async () => {
    //TODO: make it relative!
    await fetch(
      '/api/edit-client-on-facture/',
      { method: 'POST', body: JSON.stringify({ idFacture: factureId, idClient: selectedClient }) },
    );
    window.location.reload();
  };

  return (
    <KeldomAlertDialog title={"Edition du code client de la facture " + factureId} onValidate={handleChangeCodeClient} validateDisabled={!selectedClient || selectedClient === currentCustomerId}>
      <CptClientDataGrid
            currentCustomerId={currentCustomerId}
            setSelectedClient={setSelectedClient}
          />
      </KeldomAlertDialog>
  );
}
